import { render } from "./Product.vue?vue&type=template&id=2144e352&scoped=true"
import script from "../js/product.js?vue&type=script&lang=js&external"
export * from "../js/product.js?vue&type=script&lang=js&external"

import "./Product.vue?vue&type=style&index=0&id=2144e352&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2144e352"]])

export default __exports__